//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "@/mixins/global";
import chartOTP from "../../components/ChartCut";
import axios, { CancelToken } from "axios";

export default {
  components: {
    chartOTP,
  },
  data() {
    return {
      refreshComponent: false,
      // G1: true,
      // G2: true,
      // G3: true,
      // G4: true,
      // VN: true,
      locs: ["G1", "G2", "G3", "G4", "G5", "G6"],
      ps: "",
      pe: "",
    };
  },
  async mounted() {
    let a = await this.defaultPeriod();
    this.refreshComponent = true;
    // this.loadData();
  },
  computed: {},
  methods: {
    locname(loc) {
      if (loc == "G6") {
        return "VN";
      }
      if (loc == "G5") {
        return "TRM";
      }
      return loc;
    },
    goPage(routerName) {
      this.$router.push({
        name: routerName,
      });
    },

    defaultPeriod() {
      let params = new FormData();
      const obj = axios({
        method: "post",
        url: this.$apiFix + "2021snapdata.php/defaultweek",
        data: params,
      }).then((res) => {
        console.log(res.data);
        this.ps = res.data.ps;
        this.pe = res.data.pe;
      });

      return obj;
    },

    loadData() {
      this.refreshComponent = false;
      this.pulling = setTimeout(() => {
        this.refreshComponent = true;
      }, 500);
    },
  },
};
